module.exports = __webpack_public_path__ + "img/GB Logo SG_4C_Grey.a9f7f721.png";